
var cascaderLess = {};
import genaration from '../../utils/classname';
export var cascaderClass = genaration(cascaderLess, 'cascader');